function create( component, validators, options ) {

  function onInputChange( event ) {
    const target = event.target
    const value = target.value
    const name = target.name

    let allow = true
    if ( validators[name] && validators[name].active !== false ) {
      allow = ask( validators[name].allow, true, value, name, component.state )
      if ( allow === false ) {
        return
      }

      allow = typeof allow === 'string' ? allow : ask( validators[name].validator, true, value, name, component.state )
      const nState = { 
        [name] : value,
        [`${name}-error`] : allow !== true,
        [`${name}-error-msg`] : typeof allow === 'string' ? allow : null
      }

      return component.setState( nState )
    }

    component.setState( { [name] : value } )
  }
  
  function onSubmit( evt ) {
    const nState = {}
    if ( validators ) {
      Object.keys( validators ).forEach( ( k ) => {
        if ( validators[k].active === false ) {
          console.log( 'ignore', k )
          return
        }
        const v = ask( validators[k].validator, true, component.state[k], k, component.state )
        if ( v !== true ) {
          nState[`${k}-error`] = true
          nState[`${k}-error-msg`] = typeof v === 'string' ? v : null
        }
      } )
      if ( Object.keys( nState ).length > 0 ) {
        evt.preventDefault()
        return component.setState( nState )
      }
    }
    if ( options.onSubmitValidator ) {
      const v = options.onSubmitValidator( component.state ) || { errors : [] }
      v.errors.forEach( ( item ) => {
        if ( typeof item === 'string' ) {
          nState[`${item}-error`] = true
        } else if ( item ) {
          nState[`${item}-error`] = item.error
          nState[`${item}-error-msg`] = item.msg
        }
      } )
      if ( Object.keys( nState ).length > 0 ) {
        evt.preventDefault()
        return component.setState( nState )
      }

    }

    if ( options.onSubmit ) {
      evt.preventDefault()
      options.onSubmit( evt )
    }
  }

  function classnames( name, { ...extra } = {} ) {
    const cn = extra && extra.length > 0 ? [].concat( extra ) : []
    if ( validators[name] && validators[name].active === false ) {
      return cn
    }

    if ( component.state[`${name}-error`] === true ) {
      cn.push( 'error' )
    }
    return cn.join( ' ' )
  }

  function setActive( name, v ) {
    if ( validators[name] ) {
      validators[name].active = v
    }
  }

  function getActive( name ) {
    return validators[name] && validators[name].active
  }

  return {
    onInputChange,
    onSubmit,
    classnames,
    setActive,
    getActive
  }
}

function ask( obj, dValue, ...args ) {
  if ( typeof obj === 'function' ) {
    return obj.apply( this, args )
  } if ( obj instanceof RegExp ) {
    return obj.test( args[0] )
  }
  return dValue
}

function longerThan( n, trimmed ) {
  return ( v ) => { 
    console.log( 'v=', typeof v === 'string' && ( trimmed ? v.trim().length > n : v.length > n ) )
    return typeof v === 'string' && ( trimmed ? v.trim().length > n : v.length > n ) 
  }
}

module.exports = {
  longerThan,

  create
}
